import { render } from "./SmsWrongBonusDialog.vue?vue&type=template&id=619a7472&ts=true"
import script from "./SmsWrongBonusDialog.vue?vue&type=script&lang=ts"
export * from "./SmsWrongBonusDialog.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__